"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.svCommonTranslations = void 0;
exports.svCommonTranslations = {
    product: {
        unit: {
            g: 'g',
            kg: 'kg',
            ml: 'ml',
            cl: 'cl',
            dl: 'dl',
            l: 'l',
            m: 'm',
            ras: 'ask',
            tbl: 'tbl',
            plo: 'fl',
            tlk: 'brk',
            pss: 'ps',
            kpl: 'st',
            nip: 'bnt'
        },
        tag: {
            organic: 'Eko',
            local: 'Lokal',
            discount: 'Kampanj',
            new: 'Nyhet'
        },
        scaleNumber: 'Vågnummer'
    }
};
//# sourceMappingURL=sv.js.map